<template>
  <div class="content-wrapper">
    <section class="content-header">
      <h1>
        Inventory Ticket
      </h1>
      <ol class="breadcrumb">
        <li>
          <router-link :to="{ name: 'dashboard' }"><i class="fa fa-dashboard"></i> Home</router-link>
        </li>
        <li>
          <a @click="$router.go(-1)">Inventorys</a>
        </li>
        <li class="active">
          <span v-if="isCreate">Create</span>
          <span v-else>Edit</span>
        </li>
      </ol>
    </section>
    <section class="content">
      <div class="row">
        <div class="col-md-12">
          <div class="box box-info">
            <div class="box-header with-border center-ver">
              <h3 class="box-title">{{ title }}</h3>
              <a class="btn btn-success pull-right"
                @click.prevent="downloadTemplate()">
                <i class="fa fa-download"></i>  Download Template
              </a>
            </div>

            <form class="form-horizontal" @submit.prevent="submit">
              <div class="box-body" style="overflow: unset;">
                <transition name="fade">
                  <div v-if="error" class="alert alert-danger">
                    <a class="close"
                      @click="error = false">
                      &times;
                    </a>
                    {{ error }}
                  </div>
                </transition>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Name <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="text"
                      class="form-control"
                      id="name"
                      placeholder="Name"
                      v-model="form.name">
                  </div>
                </div>

                <div class="form-group">
                  <label for="name"
                    class="col-sm-2 control-label">
                    Delimiter <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <v-select
                      placeholder="Delimiter"
                      :options="list.delimiter"
                      v-model="form.delimiter">
                      </v-select>
                  </div>
                </div>

                <div class="form-group">
                  <label for="file"
                    class="col-sm-2 control-label">
                   Upload <span class="req">*</span>
                  </label>

                  <div class="col-sm-10">
                    <input type="file"
                      ref="file"
                      name="file"
                      accept="text/csv"
                      @change="setFile">
                  </div>
                </div>

                <transition name="slideDown">
                  <modal title="Select Inventory Image"
                    v-if="show.gallery">
                    <FileGallery
                      type="inventory"
                      @update-images="setImage"
                      :selected="form.image" />
                  </modal>
                </transition>
              </div>

              <div class="box-footer">
                <button type="submit" class="btn btn-info pull-right" v-if="isCreate">Create</button>
                <button type="submit" class="btn btn-info pull-right" v-else>Update</button>
                <a class="btn btn-default" @click.prevent="cancel">Cancel</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import Dropzone from 'vue2-dropzone';
import 'vue2-dropzone/dist/vue2Dropzone.min.css';
import bus from '@/utils/bus';
import Common from '@/mixins/Common';
import Modal from '@/components/modules/common/Modal';
import FileGallery from '@/components/modules/common/FileGallery';
import API_BASEURL from '@/config';
// import FileUpload from '@/components/modules/common/FileUpload';

export default {
  name: 'InventoryForm',

  mixins: [Common],

  data() {
    return {
      title: '',

      params: {
        flaging: null,
      },

      form: {
        id: null,
        name: null,
        file: null,
        delimiter: null,
        image: {
          id: null,
          url: null,
        },
      },

      tickets: [],

      list: {
        delimiter: [
          {
            label: ';',
            value: ';',
          },
          {
            label: ',',
            value: ',',
          },
        ],
      },

      inventory: {
        id: null,
        name: null,
        file: null,
      },
      show: {
        gallery: false,
      },
      configs: {
        ckeditor: {
          toolbar: [
            [
              'Styles',
              'Format',
              '-',
              'Bold',
              'Italic',
              'Strike',
              '-',
              'NumberedList',
              'BulletedList',
              '-',
              'Source',
            ],
          ],
          height: 300,
          extraPlugins: 'uploadimage',
          uploadUrl: '/static/temp/',
        },
        dropzone: {
          url: `${this.$store.state.apiBaseUrl}/ticketItems/upload`,
          method: 'put',
          acceptedFiles: 'text/csv, text/comma-separated-values, application/csv, application/x-csv, text/x-comma-separated-values, text/tab-separated-values',
          headers: {
            Authorization: `Bearer ${this.$store.state.token}`,
            'Cache-Control': '',
            'X-Requested-With': '',
          },
        },
      },
      error: null,
    };
  },

  props: {
    isCreate: {
      type: Boolean,
      required: false,
    },
  },

  components: {
    FileGallery,
    Dropzone,
    // FileUpload,
    Modal,
  },

  methods: {
    async fetch() {
      this.axios.get(`/tickets/${this.$route.params.id}`)
        .then((response) => {
          const { data } = response.data;

          this.form.id = data.id;
          this.form.name = data.name;
          this.form.file = data.file;
          this.form.delimiter.value = data.delimiter;
          // this.form.image.url = data.image_url;
        })
        .catch((error) => {
          if (error.response) {
            this.error = error.response.data.errors;
          }
        });
    },

    fetchAllTickets() {
      this.axios.get('/tickets', {
          params: {
            perpage: 1000,
          },
        })
        .then((response) => {
          const { data } = response.data;
          this.tickets = data;
        });
    },

    processFile(event) {
      this.someData = event.target.files[0];
    },

    showModal(modal) {
      this.$store.commit('SET_MODAL', modal);
      this.show[modal] = true;
      document.body.classList.add('locked');
    },

    // setImage(payload) {
    //   this.form.image = payload.images;
    // },

    setFile(e) {
      if (!e.target) {
        // alert('No file selected');
        return;
      }
      const { files } = e.target;
      this.form.file = files[0];
    },

    validate() {
      if (!this.form.name) {
        this.$swal('Name required', 'Please fill name to continue', 'warning');
        return false;
      }

      if (!this.form.delimiter) {
        this.$swal('Delimiter required', 'Please select a delimiter to continue', 'warning');
        return false;
      }

      if (!this.form.file) {
        this.$swal('Upload required', 'Please upload file to continue', 'warning');
        return false;
      }

      return true;
    },

    submit() {
      const result = this.validate();
      if (!result) return;

      if (this.isCreate) {
        this.create();
      } else {
        this.update();
      }
    },

    redirect() {
      this.$router.push({ name: 'inventory-index' });
    },

    showError(type) {
      if (type === 'ticket-exists') {
        this.$swal('Ticket Exist', 'The ticket already exists, please use the edit feature to update', 'warning');
      }

      if (type === 'ticket-failed') {
        this.$swal('Create Ticket Failed', 'Create ticket and upload stock failed', 'warning');
      }
    },

    setErrorMessage(message) {
      this.error = message;

      setTimeout(() => {
        this.error = false;
      }, 10000);
    },

    handleSubmitError(error) {
      console.log('error', error);

      if (error === 'ticket-exists') {
        this.showError('ticket-exists');
      }

      if (error === 'ticket-failed') {
        this.showError('ticket-failed');
      }

      if (error.type === 'stock-failed') {
        this.showError('stock-failed');
      }

      if (this.isCreate) {
        this.deleteTicket(this.form.id);
      }

      this.setErrorMessage(error.message);
    },

    validateTicketExist() {
      return new Promise((resolve, reject) => {
        let isExist = false;

        if (this.tickets.length > 0) {
          const ticketNames = this.tickets.map(ticket => ticket.name);
          isExist = ticketNames.includes(this.form.name);

          if (isExist) {
            reject('ticket-exists');
          } else {
            resolve();
          }
        } else {
          resolve();
        }
      });
    },

    prepareFormTicket() {
      const formData = new FormData();

      formData.append('name', this.form.name);
      formData.append('type_product', this.params.flaging);

      return formData;
    },

    submitTicket(type, dataTicket) {
      return new Promise((resolve, reject) => {
        if (type === 'create') {
          this.axios.post('/tickets', dataTicket)
            .then(response => resolve(response.data.data.id))
            .catch(() => reject('ticket-failed'));
        }

        if (type === 'update') {
          this.axios.put(`/tickets/${this.form.id}`, dataTicket)
            .then(response => resolve(response.data.data.id))
            .catch(() => reject('ticket-failed'));
        }
      });
    },

    setFormId(formId) {
      this.form.id = formId;
    },

    prepareFormStock() {
      const { id, file, delimiter } = this.form;
      const formData = new FormData();

      formData.append('ticket_id', id);
      formData.append('file', file);
      formData.append('delimiter', delimiter.value);

      return formData;
    },

    submitStock(data) {
      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      return new Promise((resolve, reject) => {
        this.axios.post('/ticketItems/upload', data, config)
          .then(() => resolve())
          .catch((error) => {
            reject({
              type: 'stock-failed',
              message: (error.response) ? error.response.data.errors : 'Error',
            });
          });
      });
    },

    deleteTicket(id) {
      return new Promise((resolve, reject) => {
        this.axios.delete(`tickets/${id}`)
          .then(() => resolve())
          .catch(error => reject(error));
      });
    },

    async create() {
      try {
        const dataTicket = this.prepareFormTicket();
        const formId = await this.submitTicket('create', dataTicket);
        this.setFormId(formId);
        const dataStock = this.prepareFormStock();
        await this.submitStock(dataStock);
        this.redirect();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    async update() {
      try {
        const dataTicket = this.prepareFormTicket();
        await this.submitTicket('update', dataTicket);

        if (this.form.file) {
          const dataStock = this.prepareFormStock();
          await this.submitStock(dataStock);
        }

        this.redirect();
      } catch (error) {
        this.handleSubmitError(error);
      }
    },

    cancel() {
      this.$router.go(-1);
    },

    async downloadTemplate() {
      const url = `${API_BASEURL}/ticketItems/export`;
      this.axios.get(url, { responseType: 'blob' })
        .then((response) => {
          const href = URL.createObjectURL(response.data);
          const link = document.createElement('a');
          link.href = href;
          link.setAttribute('download', 'Inventory Ticket.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(href);
        })
        .catch((error) => {
          console.error('[downloadTemplate]', error);
        });
    },

    setTitle() {
      if (!this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Edit Explore Inventory';
      } else if (!this.isCreate && this.params.flaging === 'tour') {
        this.title = 'Edit Tour Inventory';
      } else if (this.isCreate && this.params.flaging === 'explore') {
        this.title = 'Add New Explore Inventory';
      } else {
        this.title = 'Add New Tour Inventory';
      }
    },

    init() {
      this.params.flaging = this.$route.query.flaging || null;
      this.setTitle();
      if (!this.isCreate) {
        this.fetch();
      }
    },
  },

  created() {
    this.init();
  },

  mounted() {
    bus.$on('close-modal', () => {
      this.show.gallery = false;
    });
  },

  destroyed() {
    bus.$off('close-modal');
  },
};
</script>

<style lang="scss" scoped>
.center-ver{
  line-height: 34px;
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inventory/Form.vue